import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import { allEnumValues } from "./helper.js";
import { PrinterType } from "./printer_type.js";
//#region src/printer_type_helper.ts
var printer_type_helper_exports = /* @__PURE__ */ __exportAll({
	BuiltInKioskPrinters: () => BuiltInKioskPrinters,
	NonBuiltInPrinterTypes: () => NonBuiltInPrinterTypes,
	name: () => name,
	printerIconUrlFromType: () => printerIconUrlFromType
});
const BuiltInKioskPrinters = [
	10001,
	10002,
	10003,
	10004,
	10005
];
const NonBuiltInPrinterTypes = allEnumValues(PrinterType).filter((printerType) => {
	return !BuiltInKioskPrinters.includes(printerType) && printerType !== 0;
});
function name(printerType) {
	switch (printerType) {
		case 0: return "No Printer";
		case 1: return "TM-m30 Thermal";
		case 2: return "TM-T88V Thermal";
		case 3: return "TM-U220 Impact";
		case 4: return "TM-T88VI iHub Thermal";
		case 5: return "TM-U220i Impact";
		case 7: return "SEIKO RP-F10 Thermal";
		case 6: return "SNBC BTP-S80 Thermal";
		case 10001: return "Samsung Built-In";
		case 10002: return "LG Built-In";
		case 10003: return "Acrelec Built-In";
		case 10004: return "HP Built-In";
		case 10005: return "Posiflex Built-In";
		case 10006: return "TouchDynamic Built-In (Epson TM-m30)";
	}
}
function printerIconUrlFromType(printerType) {
	switch (printerType) {
		case 1:
		case 10006: return "https://static.bureau.getbite.com/images/status-printer-m30@2x.png";
		case 2:
		case 4: return "https://static.bureau.getbite.com/images/status-printer-tm88@2x.png";
		case 3:
		case 5: return "https://static.bureau.getbite.com/images/status-printer-u220@2x.png";
		case 7: return "https://static.bureau.getbite.com/images/status-printer-seiko-rp-f10@2x.png";
		case 6: return "https://static.bureau.getbite.com/images/status-printer-snbc-s80@2x.png";
		case 10001:
		case 10002:
		case 10003:
		case 10004:
		case 10005:
		case 0: return null;
	}
}
//#endregion
export { BuiltInKioskPrinters, NonBuiltInPrinterTypes, name, printerIconUrlFromType, printer_type_helper_exports };

//# sourceMappingURL=printer_type_helper.js.map